"use client";

import { OffersProvider } from "@/app/contexts/OffersProvider";
import { SessionProvider } from "next-auth/react";
import { ThemeProvider } from "@/components/ThemeProvider";

export function Providers({ children, session }) {
  return (
    <ThemeProvider>
      <SessionProvider session={session}>
        <OffersProvider>
          {children}
        </OffersProvider>
      </SessionProvider>
    </ThemeProvider>
  );
} 